// AppRoutes.tsx
import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { AuthenticationTitle } from './components/authentication/Authenticate';
import { AuthCallback } from './components/authentication/AuthCallback';
import { ProtectedRoute } from './ProtectedRoute';
import { AuthenticatedLayout } from './AuthenticatedLayout';
import { useAuth } from './UseAuthHook';
import { LandingPage } from './landing/LandingPage';
import SignUp from "./components/authentication/SignUp";
import {TermsAndConditions} from "./landing/TermsAndConditions";
import { PrivacyPolicy } from './landing/PrivacyPolicy';
import { BlogPage } from './blog/BlogPage'
import { FAQPage } from './faq/FAQPage'
import { Waitlist } from './components/waitlist/Waitlist'
import { Settings } from './components/settings/Settings'

export function AppRoutes() {
    const { handleLogin, isAuthenticated} = useAuth();
    const navigate = useNavigate();

    const handleLoginSuccess = async () => {
        handleLogin();
        navigate('/gallery');
    };

    return (
        <Routes>
            <Route path="/" element={<LandingPage />} />
            
            {/* Authentication Routes */}
            <Route
                path="/login"
                element={<AuthenticationTitle onLoginSuccess={handleLoginSuccess} />}
            />
            <Route
                path="/signup"
                element={<AuthenticationTitle onLoginSuccess={handleLoginSuccess} />}
            />
            <Route
                path="/verify-email"
                element={<AuthenticationTitle onLoginSuccess={handleLoginSuccess} />}
            />
            <Route
                path="/change-password"
                element={<AuthenticationTitle onLoginSuccess={handleLoginSuccess} />}
            />
            <Route
                path="/forgot-password"
                element={<AuthenticationTitle onLoginSuccess={handleLoginSuccess} />}
            />
            <Route
                path="/reset-forgotten-password"
                element={<AuthenticationTitle onLoginSuccess={handleLoginSuccess} />}
            />
            <Route
                path="/waitlist"
                element={<Waitlist />}
            />
            <Route
                path="/terms-and-conditions"
                element={<TermsAndConditions />}
            />
            <Route
                path="/privacy-policy"
                element={<PrivacyPolicy />}
            />
            {/* OAuth Callback */}
            <Route
                path="/login/callback"
                element={<AuthCallback onSuccessfulSignIn={handleLogin} />}
            />

            {/* Protected Routes */}
            <Route
                path="/blog/*"
                element={<BlogPage />}
            />
            <Route
                path="/faq"
                element={<FAQPage />}
            />
            <Route
                path="/*"
                element={<ProtectedRoute><AuthenticatedLayout /></ProtectedRoute>}
            />
        </Routes>
    );
}
